import { z } from "zod";

import { defineContractFromMeta } from "@shared/functions.ts";

const CONTRACT_NAME = "generate-derivative-dataset";

const datasetKindValues = ["behavior_examples", "operational_rules"] as const;

const DatasetKindSchema = z.enum(datasetKindValues);
export type DatasetKind = z.infer<typeof DatasetKindSchema>;

const GenerateDerivativeDatasetInputSchema = z.object({
  parentDatasetId: z.string().uuid(),
  newDatasetName: z.string().min(1),
  attackMethod: z.string().min(1),
  userId: z.string().min(1).optional(),
  datasetKind: DatasetKindSchema.optional(),
});
export type GenerateDerivativeDatasetInput = z.input<
  typeof GenerateDerivativeDatasetInputSchema
>;

const GenerateDerivativeDatasetSuccessSchema = z.object({
  success: z.literal(true),
  datasetId: z.string().uuid(),
  entriesCount: z.number().int().positive(),
});

const GenerateDerivativeDatasetErrorSchema = z.object({
  error: z.string(),
  details: z.string().optional(),
});

const GenerateDerivativeDatasetOutputSchema = z.union([
  GenerateDerivativeDatasetSuccessSchema,
  GenerateDerivativeDatasetErrorSchema,
]);
export type GenerateDerivativeDatasetOutput = z.output<
  typeof GenerateDerivativeDatasetOutputSchema
>;

const GenerateDerivativeDatasetContract = defineContractFromMeta({
  name: CONTRACT_NAME,
  meta: import.meta,
  input: GenerateDerivativeDatasetInputSchema,
  output: GenerateDerivativeDatasetOutputSchema,
  error: GenerateDerivativeDatasetErrorSchema,
});

export default GenerateDerivativeDatasetContract;
export type GenerateDerivativeDatasetContract =
  typeof GenerateDerivativeDatasetContract;
